import { EChatActionTypes } from 'shared/actions/chat';
import { EChatOnboardingActionTypes } from 'shared/actions/chatOnboarding';
import { IAppState, TActions } from 'shared/common/state';
import { getAllOfferChatOnboardings } from 'shared/utils/chatOnboarding';

export function chatOnboardingReducer(state: IAppState, action: TActions): IAppState {
  switch (action.type) {
    case 'filters/search/SEARCH_REQUEST_FINISHED':
      return {
        ...state,
        chatOnboarding: {
          ...state.chatOnboarding,
          allOfferChatOnboardings: getAllOfferChatOnboardings({
            config: state.config,
            data: action.data,
          }),
        },
      };

    case EChatActionTypes.Open:
    case EChatActionTypes.OpenAfterAuth: {
      const offerChatOnboarding = state.chatOnboarding.allOfferChatOnboardings.offerChatOnboarding;

      if (offerChatOnboarding && action.payload.offer.newbuilding?.isFromBuilder) {
        return {
          ...state,
          chatOnboarding: {
            ...state.chatOnboarding,
            allOfferChatOnboardings: {
              ...state.chatOnboarding.allOfferChatOnboardings,
              offerChatOnboarding: {
                ...offerChatOnboarding,
                wasChatOpened: true,
              },
            },
          },
        };
      }

      return state;
    }

    case EChatOnboardingActionTypes.ForceBuilderOnboardingClosing: {
      return {
        ...state,
        chatOnboarding: {
          ...state.chatOnboarding,
          builderOnboardingToForceClosing: action.payload,
        },
      };
    }
    default:
      return state;
  }
}
